import React from "react";
import "./styles.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Flex, Popconfirm } from "antd";
import { CheckItem, Tag } from "..";

const TagWidgetCard = (props) => {
  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-tag-widget-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        <div
          className="d-flex flex-row align-items-center"
          style={{ gap: "10px" }}
        >
          <div className="twcw-logo">
            <img src={props.logo} alt="logo" />
          </div>
          <div className="twcw-details-wrapper ">
            {/* <div className="twcw-title-en">{props.titleEn}</div> */}
            <div className="twcw-title-si">{props.titleSi}</div>
            <div className="twcw-date">
              Closing Date: {moment(props.closeDate).format("YYYY-MM-DD")}
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: props?.views,
                  type: "views_tag",
                }}
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-column" style={{ gap: "5px" }}>
          <div className="wgc-delete">
            <Popconfirm
              placement="topLeft"
              title="Delete the News"
              description="Are you sure to delete this News?"
              onConfirm={props.onClickDelete}
              onCancel={onClickCancel}
              okText="Yes"
              cancelText="No"
            >
              {props.delete}
            </Popconfirm>
          </div>
          <CheckItem
            data={{
              checkName: "",
              isActive: props.isSelect,
            }}
            onClick={props.onClickSelect}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(TagWidgetCard);
